export default __webpack_public_path__ + "static/media/question_15.5e904eaa.png";